function scrollToElement(id, offset = 0) {
  const element = document.querySelector(id);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition + offset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}

$('.js-scroll-to-element').on('click', function(event) {
  event.preventDefault();
  scrollToElement('.teacher-offers-request', -100);
});
